module.exports = __webpack_public_path__ + "img/logo_color.d61b3741.svg";